"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMAIN_NAMES_CODES = exports.TVA = exports.ROLES = exports.USER_GROUPS = void 0;
exports.USER_GROUPS = { NORMAL: 'normal', INTERNET: 'internet' };
exports.ROLES = {
    ADMIN: 'admin',
    SELLER: 'seller',
    PARTNER: 'partner',
    DRIVER: 'driver'
};
exports.TVA = { NORMAL: 20 };
exports.DOMAIN_NAMES_CODES = {
    'LLB': 'Loulou Bateaux',
    'LV': 'La Vernede',
    'DLMP': 'Descente Canoë Ardèche'
};
//# sourceMappingURL=constants.js.map